var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarHeart10786326(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19,2h-1v-1c0-.552-.448-1-1-1s-1,.448-1,1v1h-8v-1c0-.552-.448-1-1-1s-1,.448-1,1v1h-1C2.243,2,0,4.243,0,7v12c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V7c0-2.757-2.243-5-5-5Zm-14,2h14c1.654,0,3,1.346,3,3v1H2v-1c0-1.654,1.346-3,3-3Zm14,18H5c-1.654,0-3-1.346-3-3v-9h20v9c0,1.654-1.346,3-3,3Zm-5.108-10.115c-.755,0-1.444.305-1.969.807-.524-.501-1.214-.807-1.969-.807-1.637,0-2.969,1.436-2.969,3.2,0,1.578,1.208,3.33,3.695,5.358.36.293.801.44,1.242.439.441,0,.883-.146,1.243-.44,2.486-2.028,3.694-3.781,3.694-5.357,0-1.764-1.332-3.2-2.969-3.2Zm-1.947,7.007c-2.67-2.178-2.959-3.388-2.959-3.808,0-.662.435-1.2.969-1.2s.969.538.969,1.2c0,.552.448,1,1,1s1-.448,1-1c0-.662.435-1.2.969-1.2s.969.538.969,1.2c0,.419-.288,1.629-2.916,3.808Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarHeart10786326);
export default __webpack_public_path__ + "static/media/calendar-heart_10786326.b4d9038185f6af84b1602fe310bdaf51.svg";
export { ForwardRef as ReactComponent };